import React, { useRef, useState } from "react";
import "./Verify_Email.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Blue_White_Gradient_Btn from "../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import Gray_Btn from "../common_components/common_btn/gray_btn/Gray_Btn";
import White_Btn from "../common_components/common_btn/white_btn/White_Btn";
import {
  CheckExist,
  emailOtpGet,
  emailOtpVerify,
} from "../../utils/apis/myAccount/myAccount";
import { useForm } from "react-hook-form";
import { RegxExpression } from "../../utils/common";

import classNames from "classnames";

const Verify_Email = () => {
  const navigate = useNavigate("");
  const [showOtp, setShowOtp] = useState(false);
  const inputRefs = useRef([]);
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));


  const handleInputChange = (e, index) => {
    const { value } = e.target;

    if (value.length > 1) {
      e.target.value = value.slice(0, 1);
    }

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);

    if (index > 0 && !inputRefs.current[0].value) {
      inputRefs.current[0].focus();
      e.target.value = "";
      return;
    }

    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (
      !/^[0-9]$/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Tab" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    }

    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleContinue = () => {
    setShowOtp(true);
    if (showOtp && otpValues.every((val) => val !== "")) {
      navigate("/set-new-password");
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [showSetNewPassword, setShowSetNewPassword] = useState(false);
  const [showCheckYourEmail, setShowCheckYourEmail] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const [modalShow, setModalShow] = useState(false);
  const [email, setEmail] = useState("");

  const onSubmit = async (data) => {
    const res = await CheckExist(data);
    if (res?.success) {
      emailOtpGet(data);
      setEmail(data?.email);
      // setShowCheckYourEmail(true);
      setModalShow(true);
      setShowOtp(true);
      setTimeout(() => {
        setShowCheckYourEmail(false);
        setShowSetNewPassword(true);
        setModalShow(false);
      }, 3000);
    } else {
      setError("email", { message: "User Not Found With This E-mail" });
      // setError('contact_no', { message: "" });
    }
  };

  const handleVerifyOtp = async () => {
    const otp = otpValues.join("");
    if (otp.length !== 5) {
      alert("Please enter a valid 5-digit OTP.");
      return;
    }

    try {
      const res = await emailOtpVerify({ otp, email });
      if (res?.success) {
        navigate("/set-new-password", { state: { email } });
      } else {
        alert("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("An error occurred while verifying the OTP. Please try again.");
    }
  };

  return (
    <section className="Verify_Email Login_Signup">
      <div className="container">
        <div className="tab_container">
          <div className="login_tab_div">
            <p className="heading_title ">Reset Your Password</p>

            <Form className="login_form mt-5">
              <Form.Group className="mb-3" controlId="">
                <Form.Control
                  type="text"
                  name="email"
                  placeholder="Enter Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: RegxExpression.email,
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.email,
                    "is-valid": getValues("email"),
                  })}
                />
                {errors?.email && (
                  <div className="mt-md-0 mt-sm-3 mt-3">
                    <sup className="text-danger  ">
                      {errors?.email?.message}
                    </sup>
                  </div>
                )}
              </Form.Group>

              {showOtp && (
                <div className="otp-field-holder">
                  {[...Array(5)].map((_, index) => (
                    <Form.Control
                      key={index}
                      type="text"
                      maxLength={1}
                      value={otpValues[index]}
                      onChange={(e) => handleInputChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputRefs.current[index] = el)}
                    />
                  ))}
                  <div className="verify-otp-btn mt-3">
                    <Blue_White_Gradient_Btn
                      btn_name="Verify OTP"
                      onClick={handleVerifyOtp} // Call the OTP verification function
                    />
                  </div>
                </div>
              )}

              <div className="form_footer">
                <div className="continue_btn">
                  <Blue_White_Gradient_Btn
                    btn_name="Continue"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
                <div className="continue_btn mt-3">
                  <White_Btn
                    btn_name="Back"
                    onClick={() => {
                      navigate("/login");
                    }}
                  />
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Verify_Email;
